import { createTheme, Grid, MuiThemeProvider } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import LoadingUI from '../../../components/ui/LoadingUI'
import { useAuth } from '../../../hooks/auth'
import MvmApi from '../../../services/MvmApi'
import getDefaultGridOptions from '../../../utils/componentUtils'
import carga from '../images/package.png'
import truck from '../images/truck2.png'
import { useStyles } from '../Style'

type props =  any;

const DataGrid: React.FC<props> = ({ itemCode, type, description }) => {
    const classes = useStyles()
    const { t: tGeneral } = useTranslation("General")
    const { t: tMvm } = useTranslation("Mvm")
    const {user} = useAuth()
    const [data, setData] = useState<any>([])
    const [loading, setLoading] = useState<boolean>(false)

    const columnsShed = [
        {
            name:  'mvmNumber',
            label: tMvm("mvm"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "left",
                    }),
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },
        {
            name: 'vehiclePlateNumber',
            label: tMvm("vehiclePlateNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'shippingSupplier',
            label: tMvm("supplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'shippingCompanySupplier',
            label: tMvm("shippingCompanySupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'local',
            label: tMvm("local"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'movementType',
            label: tMvm("movementType"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'entranceTime',
            label: tMvm("entranceTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'checkInTime',
            label: tMvm("checkInTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'observation',
            label: tMvm("observation"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'tpLocal',
            label: tMvm("tpLocal"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'tpPlant',
            label: tMvm("tpPlant"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'localQuantity',
            label: tMvm("localQuantity"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        }
    ]

    const columnsConcierge = [
        {
            name: 'mvmNumber',
            label: "MVM",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "left",
                    }),
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },
        {
            name: 'vehiclePlateNumber',
            label: tMvm("vehiclePlateNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'vehicleTypeDescription',
            label: tMvm("vehicleType"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'shippingSupplier',
            label: tMvm("shippingSupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'windowTime',
            label: tMvm("windowTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'entranceTime',
            label: tMvm("entranceTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'shippingCompanySupplier',
            label: tMvm("shippingCompanySupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'windowStatusDescription',
            label: tMvm("windowStatus"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        }
    ]

    const columnsOverTime = [
        {
            name: 'mvmNumber',
            label: "MVM",
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "left",
                    }),
                setCellProps: () => ({
                    align: "left"
                }),
            }
        },
        {
            name: 'vehiclePlateNumber',
            label: tMvm("vehiclePlateNumber"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'shippingSupplier',
            label: tMvm("shippingSupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'shippingCompanySupplier',
            label: tMvm("shippingCompanySupplier"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'entranceTime',
            label: tMvm("entranceTime"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        },
        {
            name: 'tpPlant',
            label: tMvm("tpPlant"),
            options: {
                sort: false,
                setCellHeaderProps: () => ({
                    align: "center",
                    }),
                setCellProps: () => ({
                    align: "center"
                }),
            }
        }    
    ]

    useEffect(() => {

        if (!type || type === "")
            return

        setLoading(true)

        MvmApi.getMonitoringPanel({
            plantId: user.company.plantID,
            itemCode: itemCode,
            type: type
        })
        .then((response) => {
            setData(response.items)
        })
        .finally(() => setLoading(false))
    
    }, [itemCode, type, description]);

    const myTheme = createTheme({
        overrides: {
            MuiTableBody: {
                root: {
                    cursor: ''                    
                }
            },
            MuiTableCell: {
                root: {
                    paddingLeft: 4,
                    paddingRight: 4,
                    paddingBottom: 1,
                    paddingTop: 1
                },
                head: {
                    height: 52
                }
            }
        }
    })



    return (
        <Grid  style={{ width: '100%' }}>
             {
                loading ? <LoadingUI /> :
                <>
                    <Grid style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        backgroundColor: 'rgba(65,105,225, 0.5)',
                        padding: 6
                    }}>
                        <img src={truck}/>
                        <img src={carga}/>
                        <span style={{
                            fontSize: 32,
                            marginLeft: 8,
                            fontWeight: 'bold'
                        }}>{description}</span>
                    </Grid>
                    <Grid style={{ width: '100%' }}>
                        <MuiThemeProvider theme={myTheme}>
                            <MUIDataTable
                                title=""
                                data={data}
                                columns={
                                    type === 'CONCIERGE' ? 
                                        columnsConcierge : 
                                    type === 'SHED' ? 
                                        columnsShed : 
                                    type === 'OVERTIME' ? 
                                        columnsOverTime : 
                                    []} 
                                options={{
                                    ...getDefaultGridOptions(tGeneral),
                                    serverSide: true,
                                    pagination: false,
                                    sort: false,
                                    selectToolbarPlacement: "none",
                                    filter: false,
                                    search: false,
                                    download: false,
                                    print: false,
                                    viewColumns: false,
                                    selectableRows: 'none',
                                }}
                                
                            />
                        </MuiThemeProvider>
                    </Grid>
                </>
            }
        </Grid>
    )
}
export default DataGrid;
